import { createSlice } from "@reduxjs/toolkit";
import { AI_CHAT_FLOW_SLICE_NAME } from "../sliceConstants";
import extraReducers from "./thunk/aiChatExtraReducers";
import aiChatThunkActions from "./thunk/aiChatThunk";

const initialState = {
  userSearches:{
    isLoading: false,
    data: [],
    error: [],
  },
  chats:{
    isLoading: false,
    data: [],
    error: [],
  },
  feedback:{
    isLoading: false,
    data: [],
    error: [],
  },
  realTimeDate:{
    isLoading: false,
    data: [],
    error: [],
  },
  popularSearches:{
    isLoading: false,
    data: [],
    error: [],
  },
};

export const aiChatFlowSlice = createSlice({
  name: AI_CHAT_FLOW_SLICE_NAME,
  initialState,
  reducers: {
  },
  extraReducers,
});

export const aiChatActions = {
  ...aiChatFlowSlice.actions,
  ...aiChatThunkActions,
};

export default aiChatFlowSlice.reducer;
